// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hz-0";